import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss']
})
export class LogoComponent {
  @Input() feature: any;
  @Output() featureChange = new EventEmitter<any>();

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.feature.value = {
          file: file,
          url: e.target.result
        };
        this.featureChange.emit(this.feature);
      };
      reader.readAsDataURL(file);
    }
  }
}